const STORAGE_KEY = "INVOICE_PAY_TOKEN";

/* Keep the pay token per tab so guest checkout survives the acquirer's redirect. */
export function getInvoicePayToken(): string | null {
  const fromUrl = new URLSearchParams(window.location.search).get("t");

  if (fromUrl) {
    try {
      sessionStorage.setItem(STORAGE_KEY, fromUrl);
    } catch (error) {
      // The URL token still works when storage is unavailable.
    }
    return fromUrl;
  }

  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch (error) {
    return null;
  }
}
